import { render } from "./ForgotPassword.vue?vue&type=template&id=a75b58fa&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=a75b58fa&lang=scss&scoped=true"
import "./ForgotPassword.vue?vue&type=style&index=1&id=a75b58fa&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a75b58fa"]])

export default __exports__